import { render, staticRenderFns } from "./MarketCountdown.vue?vue&type=template&id=4519699e&scoped=true&"
import script from "./MarketCountdown.vue?vue&type=script&lang=js&"
export * from "./MarketCountdown.vue?vue&type=script&lang=js&"
import style0 from "./MarketCountdown.vue?vue&type=style&index=0&id=4519699e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4519699e",
  null
  
)

export default component.exports